module.exports = __webpack_public_path__ + "14_ldav_slides.pdf?65e1aff3fa6dca8c3b47e547f782fa93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/14_ldav_slides.pdf
// module id = 137
// module chunks = 0